import { useQueryClient } from '@tanstack/react-query';
import { NavLink, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Avatar, Logo, Skeleton } from './components/ui';
import { api } from './lib/api';
import { useAuth } from './lib/auth';
import { AuditPage } from './pages/Audit';
import { LoginPage } from './pages/Login';
import { ReportsPage } from './pages/Reports';
import { TeamPage } from './pages/Team';
import { TodayPage } from './pages/Today';

export default function App() {
  const { me, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="shell">
        <div className="main" style={{ display: 'grid', gap: 16, paddingTop: 60 }}>
          <Skeleton height={120} />
          <Skeleton height={240} />
        </div>
      </div>
    );
  }

  if (!me) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace state={{ from: location }} />} />
      </Routes>
    );
  }

  return (
    <div className="shell">
      <Header />
      <main className="main">
        {me.role === 'ADMIN' ? (
          // Admin só visualiza: não lança horas, então não tem a tela Hoje.
          <Routes>
            <Route path="/equipe" element={<TeamPage />} />
            <Route path="/relatorio" element={<ReportsPage />} />
            <Route path="/auditoria" element={<AuditPage />} />
            <Route path="*" element={<Navigate to="/equipe" replace />} />
          </Routes>
        ) : (
          <Routes>
            <Route path="/" element={<TodayPage />} />
            <Route path="/relatorio" element={<ReportsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        )}
      </main>
    </div>
  );
}

function Header() {
  const { me } = useAuth();
  const qc = useQueryClient();

  async function logout() {
    await api.post('/auth/logout');
    qc.clear();
    window.location.href = '/login';
  }

  return (
    <header className="header">
      <NavLink to="/" className="header__brand">
        <Logo height={26} />
        <span className="sr-only">Controle de horas</span>
      </NavLink>

      <nav className="nav" aria-label="Principal">
        {me?.role === 'ADMIN' ? (
          <>
            <NavLink to="/equipe">Equipe</NavLink>
            <NavLink to="/relatorio">Relatório</NavLink>
            <NavLink to="/auditoria">Auditoria</NavLink>
          </>
        ) : (
          <>
            <NavLink to="/" end>
              Hoje
            </NavLink>
            <NavLink to="/relatorio">Relatório</NavLink>
          </>
        )}

        <span
          style={{ width: 1, height: 24, background: 'var(--line)', margin: '0 8px' }}
          aria-hidden="true"
        />

        <Avatar name={me!.name} src={me!.avatarUrl} size={30} />
        <button className="btn btn--ghost btn--sm" onClick={() => void logout()}>
          Sair
        </button>
      </nav>
    </header>
  );
}
